// services/everpro/everpro-status.ts — cek status Everpro per-brand (tanpa secret)
// Dipakai public checkout: apakah brand ini punya Everpro (provider satu-satunya).
import { everproFetch } from './everpro-auth';

export interface BrandEverproStatus {
  configured: boolean;
  scope?: string;
  /** Toggle flatRate per-brand (Pengaturan Merek → Everpro). */
  flatRate?: boolean;
}

export async function fetchBrandEverproStatus(brandId: string, timeoutMs = 10000): Promise<BrandEverproStatus> {
  if (!brandId) return { configured: false };
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await everproFetch(brandId, '/status', { signal: ctrl.signal });
    if (!res.ok) return { configured: false };
    const json = await res.json();
    const d = json?.data ?? { configured: false };
    return { configured: !!d.configured, scope: d.scope, flatRate: !!d.flatRate };
  } catch {
    return { configured: false };
  } finally {
    clearTimeout(timer);
  }
}
